import { SearchScope } from '../utils/types';
import { http } from '../../../api/axios';
import { shopPrefix } from '../../../config';
import { ProductSearchResponseOut, TopHitOut } from '../../../store/api';

interface Params {
    query: string;
    scope: SearchScope;
    shopLanguage: string | undefined;
}

export async function fetchSearchSuggestions({ scope, query, shopLanguage }: Params) {
    const scopeKey = scope.key.toUpperCase();

    return (
        await http.get<{
            suggestions?: { [key: string]: ProductSearchResponseOut };
            topHits?: Array<TopHitOut>;
        }>(`${shopPrefix}/v2/catalogue/suggestions/${scopeKey}`, {
            params: {
                q: query,
                pageSize: 5,
                shopLanguage
            }
        })
    ).data;
}
